import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';
import { usePaymentsChartsContext } from './hooks/usePaymentsChartsContext';

export const PaymentsMonthAvg = () => {
    const { chartData } = usePaymentsChartsContext();

    const rawData = chartData?.paymentsMonth || [];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const subtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    const series = [
        {
            name: 'Valor Médio',
            data: rawData.map(item => item.avg_value)
        }
    ];

    return (
        <SimpleBars
            title="Valor Médio - Mensal"
            horizontal={false}
            subtitles={subtitles}
            series={series}
            showDataLabels={false}
        />
    );
};
